import View from "ln/view/View";

export interface ISlide {
	id:string,
	modelName: string,
	layout: string,
	title: string,
	template: string,
	courseversion: string,
	startdate: string,
	pagenumber: string
}

class SlideDetailView extends View{
	
	constructor( public data:ISlide = null ){
		super(data);
	}

	public setSlide( slide:ISlide ){
		this.data = slide;
		this.data.template = this.templateName();
	}

	/**
	 * Return template name for this slide
	 */
	protected templateName(){
		if( !this.data.layout ) return 'krw.' + this.data.modelName.replace( 'App\\', '' ).toLowerCase();
		return 'krw.' + this.data.modelName.replace( 'App\\', '' ).toLowerCase() + '__' + this.data.layout;
	}

}

export default SlideDetailView;